<template>
  <v-dialog max-width="40%" v-model="dialog">
    <template #activator="{ on }">
      <v-btn
        v-if="disabled"
        :disabled="disabled"
        small
      >
        <v-icon small left>fas fa-shower</v-icon>
        Que Up!
      </v-btn>
      <v-btn
        v-else
        v-on="on"
        color="orange"
        dark
        small
      >
        <v-icon small left>fas fa-shower</v-icon>
        Que Up!
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Get your workorder in the pipeline
        <v-spacer />
        <v-btn icon><v-icon>exit</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-select
            label="Select Your System"
            v-model="toolprocess.tool_id"
            :items="tools"
            :loading="loading"
            item-text="name"
            item-value="id"
          />
          <v-text-field
            type="Number"
            label="Estimate Days Required"
            placeholder="1"
            suffice="Days"
            v-model="toolprocess.duration_estimate"
            :rules="[() => !!toolprocess.duration_estimate || 'This field is required']"
            :error-messages="errorMessages"
            required
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" text>Close</v-btn>
        <v-btn @click="submit" text color="green">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Tool from "../../models/Tool";
import ToolProcess from "../../models/ToolProcess";
import WorkOrder from "../../models/WorkOrder";
export default {
  name: "WorkOrderTransferToQue",
  props: {
    workid: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: true,
      toolprocess: new ToolProcess(),
      errorMessages: ''
    }
  },
  computed: {
    tools() {
      return Tool
          .query()
          .where("archived", false)
          .orderBy('name')
          .get();
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Tool
        .$fetch()
        .then(() => this.loading = false)
    },
    close() {
      this.dialog = false;
    },
    submit() {
      this.toolprocess.workorder_id = parseInt(this.workid);
      ToolProcess
        .$post(this.toolprocess.toCreatePayload())
        .then(() => {
          this.close();
          WorkOrder.$get(this.workid)
      })
    }
  },
  created() {
    this.initialize()
  }
}
</script>
